export default __webpack_public_path__ + "static/char-50-31a923f756d3de7c8df3010efa104db4.webp";